import React, { ReactNode, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../ducks/hooks'
import { Menu } from 'antd'
import type { GetProp, MenuProps } from 'antd';
import { Link, useLocation } from 'react-router'
import { MenuEntry, setLayoutState } from '../../../../ducks/app'
import { default as menuData } from './menuData'
import ProfileMenu from '../MenuRight'
import './style.scss'
import { getDefaultPath } from "../../../../routes/routes";

const SubMenu = Menu.SubMenu;

interface MenuTopProps {
  isMobile: boolean;
}
type MenuItem = GetProp<MenuProps, 'items'>[number];

const MenuTop: React.FC<MenuTopProps> = ({ isMobile }) => {
  const dispatch = useAppDispatch();
  const [selectedKeys, setSelectedKeys] = useState('');
  const [openKeys, setOpenKeys] = useState(['']);
  const pathname = useLocation().pathname;
//  const collapsed = useAppSelector(state => state.app.layoutState.menuCollapsed);
  const theme = useAppSelector(state => state.app.layoutState.themeLight) ? 'light' : 'dark';
  const settingsOpened = useAppSelector(state => state.app.layoutState.settingsOpened);
  useEffect(() => {
    getActiveMenuItem(menuData);
  }, [isMobile])

  const handleClick: MenuProps['onClick'] = e => {
   if (isMobile) {
      // collapse menu on isMobile state
      dispatch(setLayoutState({ menuMobileOpened: false }))
    }
    if (e.key === 'settings') {
      // prevent click and toggle settings block on theme settings link
      dispatch(setLayoutState({ settingsOpened: !settingsOpened }))
      return
    }
    // set current selected keys
    setSelectedKeys(e.key);
    setOpenKeys(e.keyPath);
  };

  const onOpenChange: MenuProps['onOpenChange'] = openKeys => {
    setOpenKeys(openKeys);
  };

  function getPath(menuItems: MenuItem[], id: string, parents: MenuItem[] = []): MenuItem[] {
    let items = menuItems.reduce(
      (pathItems: MenuItem[], item: MenuItem) => {
        if (pathItems.length) {
          return pathItems;
        } else if (item && "url" in item && item.url === id) {
          return [item, ...parents]
        } else if (item && "children" in item && item.children) {
          let nested = getPath(item.children, id, [item, ...parents])
          return nested.length ? nested : pathItems;
        }
        return pathItems;
      },
      [] as MenuItem[],
    );
    //return items.length > 0 ? items : false
    return items;
  }

  const getActiveMenuItem = (items:MenuItem[]) => {
    //let [activeMenuItem, ...path] = getPath(items, !selectedKeys ? pathname : selectedKeys);
    let [activeMenuItem, ...path] = getPath(items, pathname === "/" ? getDefaultPath() : pathname);
    const key = (activeMenuItem?.key || '').toString();
    setSelectedKeys(key);
    setOpenKeys(activeMenuItem ? path.map(entry => (entry?.key || '').toString()) : []);
  }

  const generateMenuItems = (items:MenuEntry[]) :ReactNode[] => {
    return items.map(menuItem => {
      if ("children" in menuItem && menuItem.children) {
        let subMenuTitle = (
          <span className="menuTop__title-wrap" key={menuItem.key}>
            <span className="menuTop__item-title">{menuItem.title}</span>
            {menuItem.icon && <span className={menuItem.icon + ' menuTop__icon'} />}
          </span>
        )
        return (
          <SubMenu title={subMenuTitle} key={menuItem.key}>
            {generateMenuItems(menuItem.children)}
          </SubMenu>
        )
      }
      return generateMenuItem(menuItem)
    })
  }

  const generateMenuItem = (entry: MenuEntry): ReactNode => {
    return "url" in entry ? (
      <Menu.Item key={entry.key} disabled={entry.disabled}>
        <Link
          to={entry.url}
          onClick={
            isMobile
              ? () => {
                  dispatch(setLayoutState({ menuCollapsed: false }))
                }
              : undefined
          }
        >
          <span className="menuTop__item-title">{entry.title}</span>
          {entry.icon && <span className={entry.icon + ' menuTop__icon'} />}
        </Link>
      </Menu.Item>
    ) : (
      <Menu.Item key={entry.key} disabled={entry.disabled}>
        <span className="menuTop__item-title">{entry.title}</span>
        {entry.icon && <span className={entry.icon + ' menuTop__icon'} />}
      </Menu.Item>
    )
  }

  const menuItems = generateMenuItems(menuData);
  return (
    <div className="menuTop">
      <div className="menuTop__logo">
        <div className="menuTop__logoContainer">
          <img src="resources/images/logo-inverse.png" alt="" />
        </div>
      </div>
      <Menu
        theme={theme}
        onClick={handleClick}
        selectedKeys={[selectedKeys]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        mode="horizontal"
        className="menuTop__navigation"
      >
        <Menu.Item key={'settings'}>
          <span className="menuTop__item-title">Settings</span>
          <span className={'icmn icmn-cog menuTop__icon utils__spin-delayed--pseudo-selector'} />
        </Menu.Item>
        {menuItems}
      </Menu>
      <ProfileMenu />
    </div>
  );
}
export default MenuTop;
export { menuData };
